export default __webpack_public_path__ + "static/media/gournay5.4b4586ec.jpg";